import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import atsMatchReducer from "./atsMatchSlice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    atsMatch: atsMatchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,      
      serializableCheck: false,  
    }),
  devTools: process.env.NODE_ENV !== "production", 

});

export default store;
